<div class="medication-alerts-section"></div>

<div class="table-wrapper">
  <div class="table-header gap-4">
    <div class="align-items-center flex">
      <div>
        <button
          pButton
          pRipple
          type="button"
          [disabled]="loading"
          class="p-button-rounded p-button-text reload-btn"
          (click)="getAppLinks()"
        ></button>
      </div>
      <h2>App Link</h2>
      <div class="user-label">
        <img
          alt="app-link-icon"
          src="../../assets/images/upload-nav.svg"
        />
        <span>{{ totalApps }}</span>
      </div>
    </div>

    <div class="align-items-center flex">
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon">
          <img alt="search.svg" src="../../assets/images/search.svg" />
        </span>
        <input
          (keyup)="onSearchKeyup()"
          [(ngModel)]="searchInput"
          class="table-search-field"
          placeholder="Search app by Name or Version"
          type="text"
        />
      </div>
      <p-button
        (click)="openAddDialog()"
        label="Add New App"
        styleClass="button-sm add-icon"
      ></p-button>
    </div>
  </div>

  <p-table
    [rowHover]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [rows]="noOfRecordsPerRow"
    [showCurrentPageReport]="true"
    [value]="apps"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th id="name" [width]="'200px'">Name</th>
        <th id="app-version" [width]="'200px'">App Version</th>
        <th id="status" [width]="'120px'">Status</th>
        <th id="actions" [width]="'120px'" class="text-center">Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr (click)="onRowClick(rowData)" class="cursor-pointer">
        <td class="wrap-text">
          {{ rowData.name }}
        </td>
        <td class="wrap-text">
          {{ rowData.appVersion }}
        </td>
        <td class="wrap-text">
          <span [class]="rowData.isActive !== false ? 'status-active' : 'status-inactive'">
            {{ rowData.isActive !== false ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td class="text-center" (click)="$event.stopPropagation()">
          <div class="flex align-items-center justify-content-center gap-2">
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger"
              pTooltip="Delete App"
              tooltipPosition="left"
              (click)="onDelete(rowData)"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No App Links configured
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div>
    <p-paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfRecordsPerRow"
      [totalRecords]="totalApps"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<p-sidebar
  [(visible)]="dialogVisible"
  position="right"
  [showCloseIcon]="false"
  [dismissible]="!isBusy"
  [closeOnEscape]="!isBusy"
  (onHide)="onDialogHide()"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">
        {{ isEditMode ? 'App Details' : 'Add New App' }}
      </h2>
      <span
        (click)="isBusy ? null : onDialogHide()"
        class="cursor-pointer"
        [class.disabled-action]="isBusy"
        [class.pointer-events-none]="isBusy"
        [attr.aria-disabled]="isBusy"
      >
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="popup-wrapper">
      <div *ngIf="isBusy" class="sidebar-interaction-blocker"></div>
      <div class="form-container">
        <div class="gc-form-section">
          <form [formGroup]="appLinkForm">
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Name<span class="red">*</span></label>
                  <input
                    pInputText
                    formControlName="name"
                    placeholder="Enter app name"
                    type="text"
                    [disabled]="isBusy"
                  />
                </div>
              </div>

              <div class="grid p-fluid mt-1">
                <div class="col-12">
                  <label>App Version<span class="red">*</span></label>
                  <input
                    pInputText
                    formControlName="appVersion"
                    placeholder="Enter app version (e.g. 1.0.0)"
                    type="text"
                    [disabled]="isBusy"
                  />
                </div>
              </div>

              <div class="grid p-fluid mt-1">
                <div class="col-12">
                  <p-checkbox
                    [binary]="true"
                    formControlName="isActive"
                    inputId="isActive"
                    label="Active"
                    styleClass="checkbox-cursor-pointer"
                    [disabled]="isBusy"
                  ></p-checkbox>
                </div>
              </div>

              <div class="grid p-fluid mt-1">
                <div class="col-12">
                  <label>{{ (selectedFile || (isEditMode && selectedApp?.apkKey && !fileDeleted)) ? 'Uploaded File' : 'Upload File' }}<span *ngIf="!isEditMode" class="red">*</span></label>

                  <!-- Drag & drop style upload when no file is selected and not in edit mode with existing file -->
                  <div
                    *ngIf="!selectedFile && !(isEditMode && selectedApp?.apkKey && !fileDeleted)"
                    class="dropzone"
                    fileDragDrop
                  >
                    <div class="text-wrapper">
                      <div class="dropFile-wra">
                        <input
                          id="apkFile"
                          name="apkFile"
                          type="file"
                          accept=".apk"
                          (change)="onFileSelected($event)"
                          [disabled]="isBusy"
                        />
                        <div
                          class="flex flex-column align-items-center justify-content-center gap-4"
                        >
                          <img
                            alt="File upload"
                            src="../../assets/images/fileupload.svg"
                          />
                          <label class="textLink" for="apkFile">
                            Drag and drop file here or <u>Choose file</u>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p-progressBar
                    *ngIf="uploadProgressBar"
                    [value]="uploadProgressValue"
                    [showValue]="true"
                    class="esco-progressBar"
                  ></p-progressBar>

                  <!-- Selected file info with delete option (for new file or existing file in edit mode) -->
                  <div *ngIf="selectedFile || (isEditMode && selectedApp?.apkKey && !fileDeleted)" class="fileupload-info">
                    <div class="flex align-items-center gap-3 w-8">
                      <img alt="" src="../../assets/images/Document.svg" />
                      <label class="fileupload-text">
                        {{ selectedFile ? selectedFile.name : selectedApp?.apkKey }}
                      </label>
                    </div>
                    <div class="flex align-items-center gap-3">
                      <button
                        type="button"
                        class="btn-cancel p-button button-sm"
                        pButton
                        (click)="clearSelectedFile()"
                        [disabled]="isBusy"
                      >
                        Delete
                      </button>
                    </div>
                  </div>

                  <small
                    class="p-error"
                    *ngIf="!isEditMode && appLinkForm.get('file')?.invalid && appLinkForm.get('file')?.touched"
                  >
                    File is required
                  </small>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        pButton
        label="Cancel"
        class="btn-cancel"
        [disabled]="isBusy"
        (click)="onDialogHide()"
      ></button>

      <button
        pButton
        [label]="isEditMode ? 'Update' : 'Add'"
        [disabled]="appLinkForm.invalid || isBusy || (!isEditMode && !uploadedApkKey) || (isEditMode && !!selectedFile && !uploadedApkKey)"
        [loading]="isSubmitting"
        (click)="onSubmit()"
      ></button>
    </div>
  </ng-template>
</p-sidebar>


